import * as React from "react";
import { Field } from "redux-form";

import { TextInput } from "../../../components";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

const renderDefaultDimensionUnit = ({ defaultUnit }) => {
  switch (defaultUnit) {
    case "px":
      return " pixel";
    default:
      return ` ${defaultUnit}`;
  }
};

const renderDefaultDimension = ({ chosenProduct }: ProjectInfoFormProps) => {
  let dimension = "";

  if (chosenProduct.default_dimension_width) {
    dimension += chosenProduct.default_dimension_width;
  }
  if (chosenProduct.default_dimension_height) {
    dimension += ` x ${chosenProduct.default_dimension_height}`;
  }
  if (chosenProduct.default_dimension_depth) {
    dimension += ` x ${chosenProduct.default_dimension_depth}`;
  }
  if (chosenProduct.default_dimension_unit) {
    dimension += renderDefaultDimensionUnit({
      defaultUnit: chosenProduct.default_dimension_unit,
    });
  }

  return dimension;
};

const DimensionField = (props: ProjectInfoFormProps) =>
  <div className="form-group">
    <label className="control-label col-md-4">Kích thước</label>
    <div className="col-md-8">
      <div className="radio-block">
        <input
          type="radio"
          id="dimension-default"
          checked={props.useDefaultDimensions}
          onChange={props.toggleDefDimension}
        />
        <label htmlFor="dimension-default">
          <span className="radio-text">
            Mặc định <b>{renderDefaultDimension(props)}</b>
          </span>
        </label>
      </div>
      <div className="radio-block">
        <input
          type="radio"
          id="dimension-custom"
          checked={!props.useDefaultDimensions}
          onChange={props.toggleDefDimension}
        />
        <label htmlFor="dimension-custom">
          <p className="radio-text">Tuỳ chọn</p>
          <div className="dimension-custom__container">
            <span>
              <b>W</b>
            </span>
            <Field
              className="form-control form-control-inline"
              type="number"
              name="dimension_width"
              min={0}
              step={0.1}
              component={TextInput}
              disabled={props.useDefaultDimensions}
            />
            <span>
              x <b>H</b>
            </span>
            <Field
              className="form-control form-control-inline"
              type="number"
              name="dimension_height"
              min={0}
              step={0.1}
              component={TextInput}
              disabled={props.useDefaultDimensions}
            />
            {props.chosenProduct.default_dimension_depth &&
              <div>
                <span>
                  x <b>D</b>
                </span>
                <Field
                  className="form-control form-control-inline"
                  type="number"
                  name="dimension_depth"
                  min={0}
                  step={0.1}
                  component={TextInput}
                  disabled={props.useDefaultDimensions}
                />
                <span>
                  {props.chosenProduct.default_dimension_unit}
                </span>
              </div>}
            <span>
              <b>
                {renderDefaultDimensionUnit({
                  defaultUnit: props.chosenProduct.default_dimension_unit,
                })}
              </b>
            </span>
          </div>
        </label>
      </div>
    </div>
  </div>;

export default DimensionField;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/DimensionField.tsx